var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.24968V5.99968C5 5.06626 5 4.59956 5.18166 4.24304C5.34144 3.92944 5.59623 3.67445 5.90983 3.51466C6.26635 3.33301 6.73341 3.33301 7.66683 3.33301H14.8335C15.7669 3.33301 16.2333 3.33301 16.5898 3.51466C16.9034 3.67445 17.1587 3.92944 17.3185 4.24304C17.5002 4.59956 17.5 5.06626 17.5 5.99968V11.4997C17.5 12.4331 17.5002 12.8998 17.3185 13.2563C17.1587 13.5699 16.9034 13.8249 16.5898 13.9847C16.2333 14.1663 15.7668 14.1663 14.8333 14.1663H8.75M8.33333 9.33302V13.9997C8.33333 14.9331 8.33351 15.3998 8.15186 15.7563C7.99207 16.0699 7.73676 16.3249 7.42315 16.4847C7.06663 16.6663 6.60025 16.6663 5.66683 16.6663H5.16683C4.23341 16.6663 3.76635 16.6663 3.40983 16.4847C3.09623 16.3249 2.84144 16.0699 2.68166 15.7563C2.5 15.3998 2.5 14.9331 2.5 13.9997V9.33302C2.5 8.3996 2.5 7.93289 2.68166 7.57638C2.84144 7.26277 3.09623 7.00779 3.40983 6.848C3.76635 6.66634 4.23341 6.66634 5.16683 6.66634H5.66683C6.60025 6.66634 7.06664 6.66634 7.42315 6.848C7.73676 7.00779 7.99207 7.26277 8.15186 7.57638C8.33351 7.93289 8.33333 8.3996 8.33333 9.33302Z",
    stroke: "#D1D1D1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.a952a5e87ffde4876253a7975ca62c60.svg";
export { ForwardRef as ReactComponent };